
const KEY = "formdata"
class Settings {
    constructor() {
        //this.key = "formdata";
        let defs = {
            requestor: "",
            pi: "",
            email: "",
            institution: "",
            address: "",
            phone: "",
            rock: false,
            glass: false,
            cored_sediment: false,
            surface_sediment_grab: false,
            other: false,
            other_text: "",
            goals: "",
            material: "",
            funded: false,
            funding_info: "",
            rocks: [],
            cores: [],
            position: "",
            orcid: "",
        };
        this.data = {}
        this.read();
        if(!this.data) {
            localStorage.setItem(KEY, JSON.stringify(defs));
            this.read();
        }
        for(const key of Object.keys(defs)) {
            Object.defineProperty(this, key, {
                get() {
                    return this.data[key];
                },
                set(x) {
                    this.data[key] = x;
                    this.save();
                }
            });
            }
        
    }

    clear() {
        localStorage.clear();
    }

    read() {
        this.data = JSON.parse(localStorage.getItem(KEY));
    }

    save() {
        localStorage.setItem(KEY, JSON.stringify(this.data));
    }

    keys() {
        return Object.keys(this.data);
    }
}

export const settings = new Settings();

